// Redirects to cart page after add to cart
console.log('cart-redirect.js 6');

(function() {
    const originalFetch = window.fetch;
    window.fetch = async (...args) => {
        const response = await originalFetch(...args);

        if (args[0].includes('/cart/add')) {
            response.clone().json().then(cartItem => {
                console.log('Product added to cart:', cartItem);

                // Redirect to the correct cart page
                window.location.href = window.theme.routes.cart_url;
            });
        }

        return response;
    };
})();





